import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const LegalHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full z-50 bg-background/95 backdrop-blur-md shadow-lg">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-primary hover:text-primary/80 transition-colors">
              <span>Da</span> <span className="text-gold">Armando</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/"
              className="text-gold hover:text-gold/80 transition-colors duration-200"
            >
              Home
            </Link>
            <Link 
              to="/privacy-policy"
              className="text-gold hover:text-gold/80 transition-colors duration-200"
            >
              Privacy
            </Link>
            <Link 
              to="/cookie-policy"
              className="text-gold hover:text-gold/80 transition-colors duration-200"
            >
              Cookie
            </Link>
            <Link 
              to="/termini-condizioni"
              className="text-gold hover:text-gold/80 transition-colors duration-200"
            >
              Termini
            </Link>
            <Link 
              to="/disclaimer"
              className="text-gold hover:text-gold/80 transition-colors duration-200"
            >
              Disclaimer
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-foreground hover:text-gold transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-background/95 backdrop-blur-md border-t border-border">
            <nav className="flex flex-col space-y-4 py-6 px-4">
              <Link 
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-gold hover:text-gold/80 transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/privacy-policy"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-gold hover:text-gold/80 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/cookie-policy"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-gold hover:text-gold/80 transition-colors"
              >
                Cookie Policy
              </Link>
              <Link 
                to="/termini-condizioni"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-gold hover:text-gold/80 transition-colors"
              >
                Termini e Condizioni
              </Link>
              <Link 
                to="/disclaimer"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-gold hover:text-gold/80 transition-colors"
              >
                Disclaimer
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default LegalHeader; 